<template>
  <div class="flex flex-col items-center h-screen">
    <p class="text-xl font-bold mt-32">{{ $t('expired.title') }}</p>
    <div class="h-52"></div>
    <p class="font-bold text-center text-gray-500 mb-10">
      {{ $t('expired.description') }}<br />
      {{ $t('expired.descriptionBis') }}
    </p>
    <router-link to="/signin">
      <button class="bg-secondary text-white px-4 py-2 rounded-md mb-20">
        {{ $t('expired.requestLinkTxt') }}
      </button>
    </router-link>
    <p class="text-sm text-gray-500 mb-20">
      {{ $t('expired.contactSupportTxt') }}
      <a
        href="mailto:support@mydid.com"
        class="text-secondary hover:underline"
        >{{ $t('expired.contactSupportTxtBis') }}</a
      >
    </p>
    <img
      :src="require('/assets/images/mydid-logo-2.png')"
      alt=""
      class="w-32 self-center grayscale opacity-50"
    />
  </div>
</template>

<script>
export default {
  setup() {
    return {};
  },
};
</script>
